import { useStaticQuery, graphql } from 'gatsby'
import RichText from 'components/common/richText'
import { Section, PaddingContainer, BackgroundFill, ConditionalDiv, FlexColumn } from 'components/common/common_styles'
import { LinkButton } from 'components/common/typography'
import { useInView } from 'react-intersection-observer'
import GImage from 'components/common/gImage'
import { GridContainer, ImageContainer, TextColumn } from './homeFeatures_styles'

const HomeFeatures = () => {
  const { prismicHomePage: { data } } = useStaticQuery(query)

  return (
    <Section front>
      <BackgroundFill washi />
      <ConditionalDiv desktopOnly>
        <BackgroundFill washi bottom />
      </ConditionalDiv>
      <PaddingContainer padRight padBottom={[0, 3]}>
        <FlexColumn gap={90}>
          {data.home_features.map(feature =>
            <Feature feature={feature} key={feature.home_feature_button_link} />
          )}
        </FlexColumn>
      </PaddingContainer>
    </Section>
  )
}

export default HomeFeatures

const Feature = ({ feature }) => {
  const { ref, inView } = useInView()

  return (
    <GridContainer>
      <ImageContainer inView={inView} ref={ref}>
        <GImage data={feature.home_feature_image} />
      </ImageContainer>
      <TextColumn title={feature.home_feature_title}>
        <RichText data={feature.home_feature_copy} />
        <LinkButton link={feature.home_feature_button_link}>{feature.home_feature_button_text}</LinkButton>
      </TextColumn>
    </GridContainer>
  )
}

export const query = graphql`
  query {
    prismicHomePage {
      data {
        home_features {
          home_feature_button_link
          home_feature_button_text
          home_feature_copy {
            richText
          }
          home_feature_image {
            alt
            gatsbyImageData
          }
          home_feature_title
        }
      }
    }
  }
`
